import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import usePark from "common/hooks/usePark";
import { Enclosure } from "types/Enclosure";

const processOptions = (options: Enclosure[]) =>
  options.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

function EnclosureSelect(props: any) {
  const { park } = usePark();

  return (
    <RemoteSelect
      url="enclosures"
      processOptions={processOptions}
      filters={[{ name: "park", value: park?.id }]}
      {...props}
    />
  );
}

export default EnclosureSelect;
